import styled from 'styled-components';

export const Title = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin: 30px 45px;
`;

export const ContainerInput = styled.div`
  min-width: 353px;
  margin: 80px 0 30px;
  .MuiInputAdornment-root {
    margin-right: 20px;
  }

  .MuiInputBase-input {
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 21px;
  }
`;
export const ContainerButton = styled.div`
  margin: 10px;
  height: 35px;
  justify-content: space-between;
  img {
    width: 15px;
    margin: 0 10px 0 0;
  }
`;

export const ContainerGeneric = styled.div`
  width: 100%;
  display: flex;
  margin: 20px 0 20px 0;
  justify-content: center;
`;

export const ContainerTable = styled.div`
  display: flex;
  justify-content: center;
  maxwidth: 1300px;
  margin: 22px auto;
  .title-table {
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: 6c6c6c;
  }

  .text-table {
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    color: 6c6c6c;
  }
  
    > div {
       
        width: 900px;
        justify-content: center;
        display: flex;
        height: 154px;
        align-items: center;
        border: dashed 1px #ccc;
        }
  }



  
`;

export const ContainerModal = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 24px;
  width: 458px;

  > div {
    text-align: center;
    font-size: 17px;
    padding: 30px;
  }
`;

export const ContainerLoading = styled.div`
  display: flex;
  justify-content: 'center';
  height: 200px;
`;
